import { render, staticRenderFns } from "./CardCell.vue?vue&type=template&id=6f39e159&scoped=true"
import script from "./CardCell.vue?vue&type=script&lang=ts"
export * from "./CardCell.vue?vue&type=script&lang=ts"
import style0 from "./CardCell.vue?vue&type=style&index=0&id=6f39e159&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f39e159",
  null
  
)

export default component.exports